<template>
    <v-layout row wrap>
        <v-flex xs12>
            <cooling-load-stacked-area-plot agg="H"></cooling-load-stacked-area-plot>
        </v-flex>
        <v-flex xs6>
            <cooling-load-forecast-new></cooling-load-forecast-new>
        </v-flex>
        <v-flex xs6>
            <v-card>
                <v-card-title class="accent white--text title">
                    Latest Cooling Load Forecast Accuracy
                    <v-spacer></v-spacer>
                    <v-btn color="primary" fab small dark @click.prevent="$refs.explanationDialog.openDialog()">
                        <v-icon>fa-info</v-icon>
                    </v-btn>
                    <cooling-load-explanation ref="explanationDialog"></cooling-load-explanation>
                </v-card-title>
                <v-card-text>
                    <v-layout>
                        <v-flex xs12>
                            Forecast accuracy:
                            <vue-plotly v-if="data3" :data="data3" :layout="layout3" :options="options3"/>
                        </v-flex>

                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card>
                <v-card-text>
                    <vue-plotly v-if="data4" :data="data4" :layout="layout4" :options="options4"/>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <yearly-energy-profile></yearly-energy-profile>
        </v-flex>
        <v-flex xs12>
            <power-forecast></power-forecast>
        </v-flex>

    </v-layout>

</template>

<script>
    import CoolingLoadStackedAreaPlot from '../components/CoolingLoadStackedAreaPlot'
    import CoolingLoadForecastNew from '../components/loadforecast/CoolingLoadForecastNew'
    import CoolingLoadExplanation from '@/components/CoolingLoadExplanation'
    import VuePlotly from '@/components/VuePlotly'
    import {getResult} from '@/helper'
    import moment from 'moment'
    import YearlyEnergyProfile from "../components/YearlyEnergyProfile";
    import PowerForecast from "./PowerForecast";

export default {
  name: 'KPIView',
  components: {CoolingLoadStackedAreaPlot,CoolingLoadForecastNew,CoolingLoadExplanation,VuePlotly,YearlyEnergyProfile,PowerForecast},
    computed:{
        facilityName(){
            return this.$store.state.pointsListStore.pointsList.facility_name;
        },
        oatVar(){
            if(this.facilityName==="CRP"){
                return 'Temperature';
            } else {
                return 'Outdoor_Temperature';
            }

        },
    },
  data () {
      return {
          dateRange:[moment().subtract(5, "years").startOf('year').format('YYYY-MM-DD HH:mm'),moment().format('YYYY-MM-DD HH:mm')],
          thisMonthPower:null,
          thisYearPower:null,
          data3:null,
          data4:null,
          powerYearData:null,
          heatmapData:null,
          options3: {},
          options4: {},
          options5: {},
          options6: {},
          layout3:{
              title: 'Cooling Load Accuracy',
              hovermode: 'closest',
              xaxis: {
                  title: 'Time ',
              },
              yaxis: {
                  title: 'Cooling Load (kW)'
              },
          },
          layout4: {
              title: 'Cooling Load Accuracy Trend',
              hovermode: 'closest',
              xaxis: {
                  title: 'Time (daily)',
              },
              yaxis: {
                  title: 'Accuracy (%)',
                  range:[0,100]
              },
          }

      }
  },
    methods:{
        addArrays(ar1, ar2){
            let ar3 = [];
            for(let i in ar1)
                ar3.push(ar1[i] + ar2[i]);
            return ar3;
        }
    },
    mounted(){
      let me=this;
        getResult({
            facility_name: me.facilityName,
            result_name: 'cooling load'
        }).then(function(result){
            let actualdata = result['result'][0]['content']['df']
            let newdata = result['result'][0]['content']['forecast']
            me.data3=[
                {
                    marker: {
                        color: 'rgb(0,0,0)',
                        shape: 'spline',
                        width: 1,
                        opacity: 0.9
                    },
                    x: actualdata.timestamp,
                    y: actualdata.total_CL,
                    name: 'Actual observed value',
                    type: 'scatter',
                    mode: 'lines'
                },
                {
                    line: {
                        color: 'rgb(0,76,255)',
                        shape: 'spline',
                        width: 1,
                        opacity: 0.9
                    },
                    x: newdata.timestamp,
                    y: newdata.yhat,
                    name: 'Predicted value',
                    type: 'scatter',
                    mode: 'lines'
                },
            ]
            let differential=[];
            for(let tsindex in newdata.timestamp){
                let main=actualdata.total_CL[tsindex] ? actualdata.total_CL[tsindex] : 0
                if(main){
                    let someValue=Math.abs((main-newdata.yhat[tsindex])/main * 100);
                        if(someValue<100){
                            differential.push(100-someValue)
                        }
                } else {
                    differential.push(100)
                }

            }
            let aggregatorObj={};
            for(let tsindex in newdata.timestamp){
                let dkey=moment(newdata.timestamp[tsindex]).startOf("day").format('YYYY-MM-DD HH:mm')
                if(!(dkey in aggregatorObj)){
                    aggregatorObj[dkey]=[differential[tsindex]]
                } else {
                    aggregatorObj[dkey].push(differential[tsindex])
                }
            }
            for (let key in aggregatorObj){
                let sum = aggregatorObj[key].reduce((previous, current) => current += previous);
                aggregatorObj[key]=sum/aggregatorObj[key].length
            }
            me.data4=[
                {
                    x: Object.keys(aggregatorObj),
                    y: Object.values(aggregatorObj),
                    name: 'Differential',
                    type: 'scatter',
                    mode: 'lines'
                },
            ]
        });
    }

}
</script>

<style scoped>

</style>
